import { label } from '@entities/ksp/format';
import { useGetKspDeliveriesQuery } from '@shared/api/endpoints/ksp';
import { Notice, Small } from '@widgets/ksp-workspace/parts';
import { PagedTable } from './CollectionTable';

export function AlertDeliveries({ id }: { id: string }) {
  const { data, error } = useGetKspDeliveriesQuery(id);
  return error ? (
    <Notice $error>История доставки недоступна.</Notice>
  ) : (
    <PagedTable
      rows={data?.items ?? []}
      columns={[
        { name: 'Получатель', value: (delivery) => delivery.recipient },
        {
          name: 'Канал и день',
          value: (delivery) => `${delivery.channel} · ${delivery.local_date}`,
        },
        {
          name: 'Доставка',
          value: (delivery) => (
            <>
              {label(delivery.state)} · попыток {delivery.attempts}
              <Small>{delivery.error}</Small>
            </>
          ),
        },
      ]}
    />
  );
}
